import { render } from "./reporte_compras_almacen.vue?vue&type=template&id=565a877b&lang=es"
import script from "./reporte_compras_almacen.vue?vue&type=script&lang=js"
export * from "./reporte_compras_almacen.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__